// extracted by mini-css-extract-plugin
module.exports = {"info":"_b2073f3","infoLogo":"_ddc6b71","infoContainer":"_b4f4868"};